import React from "react";
export default function ConfigScore() {
    return(
        <>
        </>
    )
}